<!-- @format -->

<ng-container *transloco="let t">
  @if (this.localizedGraduationInstructionsUrl$ | async; as graduationInstructionsUrl) {
    <fudis-body-text>
      {{ t("GRADUATION.APPLY_FOR_GRADUATION_MODAL.GRADUATION_INSTRUCTIONS") }}
      {{ t("GRADUATION.APPLY_FOR_GRADUATION_MODAL.GRADUATION_INSTRUCTIONS_URL") }}
    </fudis-body-text>
    <fudis-body-text [class]="'fudis-mt-sm'">
      <a fudisLink [title]="graduationInstructionsUrl" [href]="graduationInstructionsUrl" [external]="true"></a>
    </fudis-body-text>
  } @else {
    <fudis-body-text>{{ t("GRADUATION.APPLY_FOR_GRADUATION_MODAL.GRADUATION_INSTRUCTIONS") }}</fudis-body-text>
  }
</ng-container>
